<template>
  <vs-popup class="formula_application_manage_popup"
            id="popup"
            title="FORMULATIONS APPLICATION UPDATE"
            @close="onClickClosePopUp"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div  id="formulation_qa_table">

<!--        <div class="vx-col w-full">-->

<!--          <v-tree ref='tree' :data='treeData' :halfcheck='true' :draggable='true' :multiple="true" :tpl='tpl'/>-->

<!--          <button @click="getSelectedNodes">click</button>-->

<!--        </div>-->



      <div class="vx-row" id="">

        <div class="vx-col w-full">
          <ejs-treeview name="tree" id='treeviewcreate' :fields="fields" :showCheckBox='true' :nodeChecked='nodeChecked' ></ejs-treeview>

        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-8">
<!--        <vs-button @click="onClickUpdateFormulaApplication" button="submit" class="ml-auto mt-2">Save Changes</vs-button>-->
        <!--        <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
      </div>
      </div>


    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const FormulationsRepository = RepositoryFactory.get('formulations')
  import { VTree, VSelectTree}  from 'vue-tree-halower'
  import {TreeViewPlugin} from "@syncfusion/ej2-vue-navigations";
  import Vue from "vue";
  Vue.use(TreeViewPlugin);

  function initialState() {
    return {
      open: false,
      id: '',
      applications: [],
      treeData: [],
      fields:{},
      formulation: {},
      selected_applications: [],
      template: "<div><vs-button @click='onClickTest()' class='ml-auto mt-2'>Save Changes</vs-button></div>"
    }
  }

export default {
  name: 'FormulationApplicationPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        await this.loadFormulations()
        await this.loadFormulationsApplications()
        this.open = true
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async loadFormulations() {
      await this.$vs.loading()
      const {data} = await FormulationsRepository.details(this.id)
      this.formulation =  data.data
      this.formulation.application_items.forEach((m) => {
        this.selected_applications.push(m.id)
      })
      this.$vs.loading.close()
    },

    async loadFormulationsApplications() {
      await this.$vs.loading({
        container: '#formulation_qa_table',
        scale: 0.45
      })
      const {data} = await FormulationsRepository.getFormulaApplications()
      this.applications =  data.data

      const nest = (items, id = null, link = 'parent_id') => items
        .filter(item => item[link] === id)
        .map(item => ({ ...item, children: nest(items, item.id), name: item.code + '- '+item.name, description: item.description, expanded: true, isChecked: this.selected_applications.includes(item.id), nocheck: false, code: item.code, is_active: item.is_active }))

      this.treeData = nest(this.applications)

      this.fields = {
        dataSource: this.treeData,
        id: 'id',
        parentID: 'parent_id',
        text: 'name',
        child: 'children'
      }

      this.$vs.loading.close('#formulation_qa_table > .con-vs-loading')
    },
    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return <span>
      <span class={titleClass} domPropsInnerHTML={node.code + ' - ' + node.name} onClick={() => {
        this.$refs.tree.nodeSelected(node)
      }}></span>
      <button class="btn-async text-warning border-none cursor-pointer px-2 py-1 mr-2 rounded" onClick={() => this.asyncLoad(node)}>update</button>
      <button class="btn-delete text-danger border-none cursor-pointer px-2 py-1 rounded" onClick={() => this.$refs.tree.delNode(node, parent, index)}>delete</button>
      </span>
    },
    nodeChecked: function(args) {
      const treeObj = document.getElementById('treeviewcreate').ej2_instances[0];
      this.selected_applications = treeObj.checkedNodes
      this.onClickUpdateFormulaApplication()
    },
    async onClickUpdateFormulaApplication() {
      const vue = this;
      try {
        await this.$vs.loading({
          container: '#popup',
          scale: 0.45
        })
        await FormulationsRepository.updateFormulationsApplications(this.id, {
          application_items: this.selected_applications
        })
        // this.showSuccessMessage('Formulation applications updated');
        // this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    onClickTest() {

    },
    async onClickClosePopUp() {
      await this.$parent.refreshData()
      this.open = false
    }
  },
  async mounted () {

  },
  components: {
    VTree,
    VSelectTree
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  /*@import "@/assets/scss/vuexy/extraComponents/tree.scss";*/
  .e-treeview.e-fullrow-wrap .e-text-content {
    pointer-events:auto;
  }

  .formula_application_manage_popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }


  button.btn-async{
    background: rgba(var(--vs-warning),0.15);
  }

  button.btn-delete{
    background: rgba(var(--vs-danger),0.15);
  }
</style>
